import createLogger from "Utils/logger"

export const logger = createLogger("Components/Inquiry")
